/**
 * @generated SignedSource<<1070abbdf46f82d92beacd38d03c138b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type PrivacySettingsQmeeQuery$variables = {};
export type PrivacySettingsQmeeQuery$data = {
  readonly consentSettings: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
      readonly node: {
        readonly description: {
          readonly subtitle: string | null;
          readonly title: string;
        };
        readonly href: string | null;
        readonly id: string;
        readonly userResponse: {
          readonly answerKeys: ReadonlyArray<string | null> | null;
          readonly label: string | null;
        } | null;
      };
    }>;
  } | null;
};
export type PrivacySettingsQmeeQuery = {
  response: PrivacySettingsQmeeQuery$data;
  variables: PrivacySettingsQmeeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "serviceProvider",
    "value": "QMEE"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "QuestionDescription",
  "kind": "LinkedField",
  "name": "description",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subtitle",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "href",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "answerKeys",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PrivacySettingsQmeeQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "ConsentSettingsConnection",
        "kind": "LinkedField",
        "name": "consentSettings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ConsentSettingEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ConsentSetting",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserQuestionResponse",
                    "kind": "LinkedField",
                    "name": "userResponse",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "consentSettings(serviceProvider:\"QMEE\")"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PrivacySettingsQmeeQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "ConsentSettingsConnection",
        "kind": "LinkedField",
        "name": "consentSettings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ConsentSettingEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ConsentSetting",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserQuestionResponse",
                    "kind": "LinkedField",
                    "name": "userResponse",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "consentSettings(serviceProvider:\"QMEE\")"
      }
    ]
  },
  "params": {
    "cacheID": "bb204cd381e2b63c632609066f7e6a30",
    "id": null,
    "metadata": {},
    "name": "PrivacySettingsQmeeQuery",
    "operationKind": "query",
    "text": "query PrivacySettingsQmeeQuery {\n  consentSettings(serviceProvider: QMEE) {\n    edges {\n      cursor\n      node {\n        id\n        description {\n          title\n          subtitle\n        }\n        href\n        userResponse {\n          answerKeys\n          label\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ffddf1755bd15c3ee6bf2a0be26bc6a7";

export default node;
